module.exports = __webpack_public_path__ + "img/banner.b085bc14.png";